import React from 'react';
import { StringParam, useQueryParam } from 'use-query-params';

import { Study } from 'interfaces/study';
import StudyExportMenuItem from './StudyExportMenuItem';

interface StudyExportMenuItemsProps {
  study?: Study;
  disabled: boolean;
  onOpenExportData: () => void;
}

// The prepared-bundles item stays until Jobs offers the exact-job and latest retrieval actions.
const StudyExportMenuItems: React.FunctionComponent<StudyExportMenuItemsProps> = ({
  study,
  disabled,
  onOpenExportData,
}) => {
  const [, setSelectPrepareJobToExportModalStudyId] = useQueryParam(
    'selectPrepareJobToExportModalStudyId',
    StringParam
  );
  const isExportDataDisabled = disabled || !study?.allowExport;
  const isPreparedBundlesDisabled = !study?.allowExport || !study?.hasResults;

  return (
    <>
      <StudyExportMenuItem
        title="Export data"
        secondaryText="Choose what to export"
        disabled={isExportDataDisabled}
        disabledMessage="Exports are disabled for this study"
        onClick={() => !isExportDataDisabled && onOpenExportData()}
      />
      <StudyExportMenuItem
        title="Prepared Zip Bundles for Customer Results"
        disabled={isPreparedBundlesDisabled}
        disabledMessage={study?.allowExport ? 'No results to export' : 'Exports are disabled for this study'}
        onClick={() => !isPreparedBundlesDisabled && setSelectPrepareJobToExportModalStudyId(study?.id)}
      />
    </>
  );
};

export default StudyExportMenuItems;
